<p *ngIf="'text' === linkItem?.type" class="{{linkItem.classes}}" [innerHTML]="linkItem.text | safeHtml"></p>
<span *ngIf="'title' === linkItem?.type" class="{{linkItem.classes}}">
    <ng-container *ngFor="let titleText of linkItem.items">
        <p *ngIf="'text' === titleText.type" class="{{titleText.classes}}" [innerHTML]="titleText.text | safeHtml"></p>
    </ng-container>
</span>
<img *ngIf="'image' === linkItem?.type"
    [class]="linkItem.classes"
    [src]="linkItem.src || ''"
    [alt]="linkItem.altText"
    storyImage="true"
>
<!--
    TODO: hide images on other screensizes type stuff
    data-image="{{(linkItem.visibleClasses ? linkItem.classes.indexOf(storyBlockControllerVm.visibleMediaQuery.className) > -1 : true) && linkItem.src || ''}}"
    ng-src="{{linkItem.loadImage && (linkItem.visibleClasses ? linkItem.classes.indexOf(storyBlockControllerVm.visibleMediaQuery.className) > -1 : true) && linkItem.src || ''}}"
-->
